import { gql } from '@apollo/client';

export const GENERATE_EXCEPTION_ORDER_DOWNLOAD_REPORT = gql`
    mutation GenerateExceptionOrderDownloadReport(
        $warehouseId: Long!
        $filters: ExceptionOrderFiltersTypeInput
        $timezone: String
    ) {
        generateExceptionOrderDownloadReport(warehouseId: $warehouseId, filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateExceptionOrderDownloadReportResponse {
    generateExceptionOrderDownloadReport: string;
}

export interface GenerateExceptionOrderDownloadReportVariables {
    warehouseId: number;
    filters?: any;
    timezone?: string;
}
